import { claudeService } from './claudeService';
import { openaiService } from './openaiService';
import { geminiService } from './geminiService';

const API_PROVIDERS = {
  claude: claudeService,
  openai: openaiService,
  gemini: geminiService
};

export const aiServiceSelector = {
  getCurrentProvider() {
    return import.meta.env.VITE_REACT_AI_PROVIDER || 'claude';
  },

  async sendMessage(message, context, portfolioData = null) {
    const provider = this.getCurrentProvider();
    const service = API_PROVIDERS[provider];
    
    if (!service) {
      throw new Error(`Unknown AI provider: ${provider}`);
    }
    
    console.log(`Using AI provider: ${provider}`);
    return await service.sendMessage(message, context, portfolioData);
  },

  getAvailableProviders() {
    return Object.keys(API_PROVIDERS);
  }
};